module.exports = __webpack_public_path__ + "img/menu.e1660dfd.png";